document.addEventListener("DOMContentLoaded", function () {
  const totalEl = document.getElementById("pw-total");
  const discountedTotalEl = document.getElementById("pw-discountedtotal");
  const addBtn = document.getElementById("pw-add-to-cart");
  const totalItems = document.querySelectorAll(".pw-item").length;
  const checkedBoxes = document.querySelectorAll('.pw-checkbox:checked');
 async function getCartInfo() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return {
      total: cart.total_price / 100, // Convert from cents/pence
      currency: theme.settings.cartCurrency
    };
  } catch (e) {
    return { total: 0, currency: theme.settings.cartCurrency };
  }
}

   async function updateTotal() {
  let total = 0;

  document.querySelectorAll(".pw-item").forEach(item => {
    const checkbox = item.querySelector(".pw-checkbox");
    const variant = item.querySelector(".pw-variant");
    const productId = item.dataset.productId;

    // Get corresponding image
    const imageEl = document.querySelector(`.pw-image-item[data-product-id='${productId}']`);

    if (checkbox && imageEl) {
      if (checkbox.checked) {
        imageEl.classList.remove("blurred");
      } else {
        imageEl.classList.add("blurred");
      }
    }

    if (checkbox && checkbox.checked && variant) {
      const selectedOption = variant.options[variant.selectedIndex];
      const price = parseFloat(selectedOption.dataset.price) || 0;
      total += price;
    }
  });

    // Get cart info for discount logic
  const cartInfo = await getCartInfo();
  let cartTotal = parseFloat(cartInfo.total);
  const currency = cartInfo.currency;
  const discount = (total * 0.10).toFixed(2);
  const discountedTotal = (total - discount).toFixed(2);
  cartTotal += parseFloat(total); // Add selected items to cart total


  let showDiscount = false;
  if ((currency === '£' && cartTotal > 90) || (currency === '€' && cartTotal > 120)) {
    showDiscount = true;
  } 
    if (totalEl && discountedTotalEl) {
      if(totalItems > 1 && document.querySelectorAll('.pw-checkbox:checked').length === totalItems && showDiscount) {
        discountedTotalEl.style.display = "inline";
        discountedTotalEl.innerHTML = `${theme.Currency.formatMoney(discountedTotal * 100, theme.settings.moneyFormat)}`;
        totalEl.innerHTML =`<s>${theme.Currency.formatMoney(total * 100, theme.settings.moneyFormat)}</s>`;
      } else {
        discountedTotalEl.style.display = "none";
        discountedTotalEl.innerHTML = "";
        totalEl.innerHTML = theme.Currency.formatMoney(total * 100, theme.settings.moneyFormat);

      }
    }

    if (addBtn) {
      const anyChecked = document.querySelectorAll(".pw-checkbox:checked").length > 0;
      addBtn.disabled = !anyChecked;
    }
}
  document.querySelectorAll(".pw-checkbox, .pw-variant").forEach(el => {
    el.addEventListener("change", updateTotal);
  });

  updateTotal();

  if (addBtn) {
    addBtn.addEventListener("click", function (e) {
      e.preventDefault();

      const items = [];
      document.querySelectorAll(".pw-item").forEach(item => {
        const checkbox = item.querySelector(".pw-checkbox");
        const variant = item.querySelector(".pw-variant");
        let bundleID = item.dataset.bundleId || null;
        let dateAndTime = new Date();
        dateAndTime = dateAndTime.toISOString();
        if (checkbox && checkbox.checked && variant) {
          const variantId = Number(variant.value);
          if (variantId > 0 && (!bundleID || bundleID.length === 0)) {
            items.push({ id: variantId, quantity: 1 });
          }else if (variantId > 0 && bundleID && bundleID.length > 0) {
            bundleID = bundleID.replace("date", dateAndTime);
            items.push({ id: variantId, quantity: 1 , properties: { _bundle_id: bundleID }});
          }
        }
      });

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ items })
      })
      .then(res => res.json())
      .then(data => {
        document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: data, bubbles: true }));
      })
    });
  }
  // Listen to Shopify cart events
document.addEventListener("ajaxProduct:added", updateTotal);
document.addEventListener("cart:refresh", updateTotal);
document.addEventListener("cart:updated", updateTotal);
document.addEventListener("cart:change", updateTotal);


  // scroll for style-with-section link

  document.querySelectorAll('a[href="#style-with-section"]').forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector("#style-with-section");
      if (!target) return;

      const headerOffset = 130;
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    });
  });
});

